export interface ConditionedAttribute {
  condition: object | undefined;
  result: any;
}

export function conditionedAttribute(
  origObject: { [key: string]: any } | undefined,
  originName: string,
  fallbackDefault?: any,
): ConditionedAttribute[] {
  if (origObject === undefined) {
    return [];
  }
  let origName = getUnconditionalName(originName);
  let result = [];
  if (origObject[origName] !== undefined) {
    result.push({ condition: undefined, result: origObject[origName] });
  }
  result = result.concat(origObject["__cond_" + origName] ?? []);

  if (result.length === 0 && fallbackDefault) {
    result.push({ condition: undefined, result: fallbackDefault });
  }

  return result;
}

export function getUnconditionalName(attrName: string) {
  if (attrName.startsWith("__cond_")) {
    return attrName.slice(7);
  }
  return attrName;
}

export function getConditionedPath(path: string[], selectedCondition: number, conditions: ConditionedAttribute[]) {
  let conditionedAttribute = conditions[selectedCondition];
  if (conditionedAttribute !== undefined && conditionedAttribute.condition === undefined && selectedCondition === 0) {
    return path;
  }

  let selectedConditionIndex = selectedCondition;
  if (conditions[0].condition === undefined) {
    selectedConditionIndex--;
  }

  let target = path.slice();
  target[target.length - 1] = "__cond_" + target.at(-1);
  target.push(selectedConditionIndex.toString());
  return target;
}

export function getPathToConditionCheck(
  path: string[],
  selectedCondition: number,
  conditions?: ConditionedAttribute[],
) {
  // Editing a condition check
  const checkIndex = path.at(-2);
  const targetKey = path.at(-1);

  let pathToConditionCheck = path.slice();
  const targetPropertyIndex = pathToConditionCheck.length - 2;

  pathToConditionCheck[targetPropertyIndex] = "__cond_" + pathToConditionCheck[targetPropertyIndex];
  const targetConditionIndex = selectedCondition - 1;
  pathToConditionCheck.splice(-1, 0, targetConditionIndex.toString());
  // TODO pokud jsme na indexu selectedCondition === 0 tak musime posunout vsechny indexy o 1 a smazat non cond.
  return pathToConditionCheck;
}

export function buildConditionedPath(
  selectedConditionId: number,
  propertyName: string,
  conditions: ConditionedAttribute[],
  conditionalSpecification?: string,
): string[] {
  let propName: string[];
  if (selectedConditionId === 0 && conditions[0].condition === undefined) {
    propName = [propertyName];
  } else {
    let selectedConditionIndex = selectedConditionId;
    if (conditions[0].condition === undefined) {
      selectedConditionIndex--;
    }
    propName = ["__cond_" + propertyName, selectedConditionIndex.toString()];

    if (conditionalSpecification) {
      propName.push(conditionalSpecification);
    }
  }
  return propName;
}
